import React from "react";

interface BoxProps {
  width: number;
  height: number;
  depth: number;
  lineWidth: number;
  lineColor: number;
}
export const Box: React.FC<BoxProps> = ({
  width,
  height,
  depth,
  lineWidth,
  lineColor,
}) => (
  <group>
    <mesh position={[0, -height / 2 + lineWidth / 2, -depth / 2]}>
      <boxBufferGeometry args={[width, lineWidth, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[0, height / 2 - lineWidth / 2, -depth / 2]}>
      <boxBufferGeometry args={[width, lineWidth, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[-width / 2 + lineWidth / 2, 0, -depth / 2]}>
      <boxBufferGeometry args={[lineWidth, height, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[width / 2 - lineWidth / 2, 0, -depth / 2]}>
      <boxBufferGeometry args={[lineWidth, height, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[0, -height / 2 + lineWidth / 2, depth / 2]}>
      <boxBufferGeometry args={[width, lineWidth, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[0, height / 2 - lineWidth / 2, depth / 2]}>
      <boxBufferGeometry args={[width, lineWidth, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[-width / 2 + lineWidth / 2, 0, depth / 2]}>
      <boxBufferGeometry args={[lineWidth, height, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[width / 2 - lineWidth / 2, 0, depth / 2]}>
      <boxBufferGeometry args={[lineWidth, height, lineWidth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh position={[width / 2 - lineWidth / 2, height / 2 - lineWidth / 2, 0]}>
      <boxBufferGeometry args={[lineWidth, lineWidth, depth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh
      position={[width / 2 - lineWidth / 2, -height / 2 + lineWidth / 2, 0]}
    >
      <boxBufferGeometry args={[lineWidth, lineWidth, depth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh
      position={[-width / 2 + lineWidth / 2, height / 2 - lineWidth / 2, 0]}
    >
      <boxBufferGeometry args={[lineWidth, lineWidth, depth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
    <mesh
      position={[-width / 2 + lineWidth / 2, -height / 2 + lineWidth / 2, 0]}
    >
      <boxBufferGeometry args={[lineWidth, lineWidth, depth]} />
      <meshBasicMaterial color={lineColor} />
    </mesh>
  </group>
);
